ConfirmModalCtrl.$inject = ['$uibModalInstance', 'message'];
export default function ConfirmModalCtrl($uibModalInstance, message) {
    var confirmCtrl = this;
    confirmCtrl.message = message;
    confirmCtrl.ok = function () {
        $uibModalInstance.close();
    };
    confirmCtrl.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
}
